import React from "react";
import PropTypes from "prop-types";
import css from "./ScheduleDisplayPreview.scss";
import DayScheduleView from "common/DayScheduleView";
import {SFVirtualCheckInDaySchedule} from "utils/types";
import {isEmptyString} from "utils/text";
import {tenantTimeZoneLongForm} from "utils/tenant";

//Valid slot is when a slot is not empty or does not have errors
function validSlot(slot) {
    return slot.openTime !== "" && slot.closeTime !== "" && (!slot.hasOwnProperty("overlapError")  || isEmptyString(slot.overlapError))
}

const validDay = (day) => {
   return {...day, timeSlots: day.timeSlots.filter(validSlot)};
}

function nonEmptyDayOfWeek(day) {
     return day.dayOfWeek !== "";
}

function scheduleExists(schedule) {
    return schedule && schedule.length > 0;
}

function renderContent(schedule) {
    const validSchedule =
        schedule
            .filter(nonEmptyDayOfWeek)
            .map(validDay)
            .filter(day => day.timeSlots.length);

    if(!scheduleExists(validSchedule)) {
       return <span className={css['empty-text']}>Add Days & Times to Virtual Check-in Open Hours to preview</span>
    }

    return (
        <>
            <span className={css['preview-header']}>Join Waiting Room online during these hours shown in time zone: {tenantTimeZoneLongForm()}</span>
            <div className={css['schedule-hours']}>
                {validSchedule.map((day, key) => <DayScheduleView key={key} day={day} />)}
            </div>
        </>)
}

const ScheduleDisplayPreview = ({schedule}) => {
    return (
        <div className={css['preview']}>
            <span className={css['heading']}>Display Preview</span>
            <div className={css['preview-info']}>
                This is what will display to users for the availability of this Virtual Kiosk.
                After saving, your time slots will automatically be ordered from Monday to Sunday.
                <span className={css['bolded']}>Note: Users can only see this if virtual check-in is enabled above.</span>
            </div>
            <div className={css['hours-preview']}>
                <div className={css['preview-content']}>
                    {renderContent(schedule)}
                </div>
            </div>
        </div>
    )
}

ScheduleDisplayPreview.propTypes = {
    schedule: PropTypes.arrayOf(SFVirtualCheckInDaySchedule)
}

export default ScheduleDisplayPreview;
